import { TitleCasePipe } from '@angular/common';

export const getLoanStatuses = (name) => {
  const pipe: TitleCasePipe = new TitleCasePipe();
  const username = pipe.transform(name.split(' ')[0]);
  return {
    behind: {
      greeting: `Hey ${username}!`,
      message: `Just a kind reminder, I do need your help. There are tasks to be completed for your loan application.`,
      status: 'Falling behind'
    },
    done: {
      greeting: `Way to go ${username}!`,
      message: `You did it! All tasks are completed for your loan application. I'll let you know the next steps!`,
      status: 'Done!'
    },
    initialLogin: {
      greeting: `Welcome ${username}!`,
      message: `We're getting started on this journey together and I'll need your help along the way.`,
      status: 'Welcome!'
    },
    onTime: {
      greeting: `Hey ${username}!`,
      message: `You're progressing nicely! Your application should close on time.`,
      status: 'On time'
    }
  };
};

export const DEFAULT_VALUE = '';
// Refresh token session length is 16 minutes
export const REFRESH_TOKEN_SESSION_LENGTH = 960000;
// STORAGE PREFIX FOR BUSINESS INFORMATION
export const STORAGE_PREFIX_ID = 'api:oaoMemberInformation/businessInformation';
// BUSINESS RESPONSIBLE PARTIES ID
export const RESPONSIBLE_PARTIES = STORAGE_PREFIX_ID + '/responsibleParties';
// BUSINESS RESPONSIBLE IS PARTY ID
export const RESPONSIBLE_PARTIES_ISPARTY = RESPONSIBLE_PARTIES + '/$/isResponsibleParty';
// Additional Beneficary id for Business
export const ADDITIONAL_BENEFICIAL_COUNT = STORAGE_PREFIX_ID + '/additionalBeneficialOwnerCount';
// OAO Membership Type
export const OAO_MEMBERSHIP_TYPE = 'api:oaoMemberInformation/membership/membershipTypeName';
